import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import routes, { IRoute } from 'routes';

import './reset.styl';

export const RootLayout = () => (
  <Switch>
    {routes.map(
      ({ component, layout: Layout, layoutProps = {}, ...route }: IRoute) => {
        const Component = component as React.ElementType;

        const renderedComponent = (props: unknown) =>
          Layout ? (
            <Layout {...layoutProps}>
              <Component {...props} />
            </Layout>
          ) : (
            <Component {...props} />
          );

        return (
          <Route
            key={String(route.path)}
            {...route}
            exact={Boolean(route.exact)}
            render={renderedComponent}
          />
        );
      },
    )}
  </Switch>
);
